import { FilledButton } from '../util/button';
import { EntryField } from '../util/common/entryField';
import { ListItemPicker } from '../util/listSelectField';
import './repairPickUpReserve.css';

interface RepairPickUpReserveProps {
  onNext: () => void;
  disabled: boolean;
  firstPreferredDate: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  secondPreferredDate: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  thirdPreferredDate: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  firstPreferredTime: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  secondPreferredTime: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
  thirdPreferredTime: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
}
export const RepairPickUpReserve = ({
  onNext,
  disabled,
  firstPreferredDate,
  secondPreferredDate,
  thirdPreferredDate,
  firstPreferredTime,
  secondPreferredTime,
  thirdPreferredTime,
}: RepairPickUpReserveProps) => {
  const RepairPickUpReserveHeader = () => {
    return (
      <div className={'reserve-select-entry-header'}>
        <div className={'reserve-select-entry-note'}>
          <span>{'※全て必須項目です。'}</span>
        </div>
        <div className={'reserve-select-entry-label'}>
          <span>{'ご希望のご返却日を選択してください'}</span>
        </div>
      </div>
    );
  };
  return (
    <div className={'pick-up-reserve-select-field'}>
      <div className={'reserve-select-entry-field'}>
        <RepairPickUpReserveHeader />
        <EntryField label={'第一希望'} required={true}>
          <div className={'preferred-entry-field first'}>
            <div className={'date-select-field'}>
              <div className={'date-select-label'}>
                <span>{'日付'}</span>
              </div>
              <ListItemPicker
                pickerSelect={firstPreferredDate.pickerSelect}
                pickerInputID={firstPreferredDate.pickerInputID}
                pickerContainerID={firstPreferredDate.pickerContainerID}
              />
            </div>
            <div className={'time-select-field'}>
              <div className={'time-select-label'}>
                <span>{'時間'}</span>
              </div>
              <ListItemPicker
                pickerSelect={firstPreferredTime.pickerSelect}
                pickerInputID={firstPreferredTime.pickerInputID}
                pickerContainerID={firstPreferredTime.pickerContainerID}
              />
            </div>
          </div>
        </EntryField>
        <EntryField label={'第二希望'} required={false}>
          <div className={'preferred-entry-field second'}>
            <div className={'date-select-field'}>
              <div className={'date-select-label'}>
                <span>{'日付'}</span>
              </div>
              <ListItemPicker
                pickerSelect={secondPreferredDate.pickerSelect}
                pickerInputID={secondPreferredDate.pickerInputID}
                pickerContainerID={secondPreferredDate.pickerContainerID}
              />
            </div>
            <div className={'time-select-field'}>
              <div className={'time-select-label'}>
                <span>{'時間'}</span>
              </div>
              <ListItemPicker
                pickerSelect={secondPreferredTime.pickerSelect}
                pickerInputID={secondPreferredTime.pickerInputID}
                pickerContainerID={secondPreferredTime.pickerContainerID}
              />
            </div>
          </div>
        </EntryField>
        <EntryField label={'第三希望'} required={false}>
          <div className={'preferred-entry-field third'}>
            <div className={'date-select-field'}>
              <div className={'date-select-label'}>
                <span>{'日付'}</span>
              </div>
              <ListItemPicker
                pickerSelect={thirdPreferredDate.pickerSelect}
                pickerInputID={thirdPreferredDate.pickerInputID}
                pickerContainerID={thirdPreferredDate.pickerContainerID}
              />
            </div>
            <div className={'time-select-field'}>
              <div className={'time-select-label'}>
                <span>{'時間'}</span>
              </div>
              <ListItemPicker
                pickerSelect={thirdPreferredTime.pickerSelect}
                pickerInputID={thirdPreferredTime.pickerInputID}
                pickerContainerID={thirdPreferredTime.pickerContainerID}
              />
            </div>
          </div>
        </EntryField>
      </div>
      <div className={'reserve-select-button-field'}>
        <FilledButton onClick={onNext} label={'次へ'} disabled={disabled} />
      </div>
    </div>
  );
};
